export const PlatformDetailsSection = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <div className="text-sm leading-tight">
    <h2 className="text-sm font-semibold leading-tight mb-2">{title}</h2>
    {children}
  </div>
);

export const PlatformSetupSection = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <div className="text-sm leading-tight">
    <h1 className="text-lg font-semibold leading-tight mb-2">{title}</h1>
    {children}
  </div>
);

export const SectionSeparator = () => (
  <div className="w-full h-6 mt-6 border-t border-gray" />
);
